<template>
<div id="customerInvoiceLineDetailReport">
  <div :class="`loader${loaderClass}`" v-show="loading"></div>
  <div id="page-content-wrapper" class="admin-content-area" >
    <template v-if="cantAccessPage === true">
      <div class="page-name">
        <div class="page-title">Customer Invoice Line Detail</div>
        <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content contact-list">
          <data-table-filter-config :moduleName="'customerInvoiceLineDetailReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
          <section class="bg-white data-table">
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'customerInvoiceLineDetailReport'" :position="'top'">
            </custom-pagination>

            <vue-good-table
                mode="remote"
                ref="customerInvoiceLineDetailReportTable"
                title="Customer Invoice Line Detail Report"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :paginationOptions="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    dropdownAllowAll: false,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                }"
                :search-options="{
                enabled: false,
                }"

                >
            </vue-good-table>
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
            </custom-pagination>
          </section>
        </div>
      </div>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
      </div>
    </template>
    <template v-else>
      <loading-content></loading-content>
    </template>
    <app-footer></app-footer>
  </div>
</div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../mixins/commonMixins';
 import {dataTableMixins} from '../mixins/dataTableMixins';
 let msgServer;
export default {
    name: "LeaseContract",
    metaInfo(){
        return {
            title : 'Invoice Detail Report | FleetPro Application'
        }
        },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        cantAccessPage:"",
        loading: false,
        action: 'list',
        permissions:[],
        rows: [],
        totalRecords: 0,
        userColumns:[],
        columns:[
            {
            label: 'Customer Name',
            field: 'customer_name',
            fpFieldType:"text",
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Name", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
            {
            label: 'Customer Number',
            field: 'customer_code',
            fpFieldType:"text",
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Name", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        
        //   {
        //       label: 'Inv Source',
        //       field: 'invoice_type',
        //       fpFieldType:"option",
        //       hidden:false,
        //       filterable: true,
        //       filterOptions: {
        //           enabled: false, // enable filter for this column
        //           placeholder: "Inv Type", // placeholder for filter input
        //           filterValue: '', // initial populated value for this filter
        //           trigger: "enter" //only trigger on enter not on keyup
        //       },
        //   },
        {
            label: 'Invoice Number',
            field: 'invoice_number',
            filterable: true,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'WO Number',
            field: 'work_order_no',
            filterable: true,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Invoice Line',
            field: 'inv_line',
            fpFieldType:"integer",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Invoice Date',
            field: 'invoice_date',
            filterable: true,
            fpFieldType:"date",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Misc Unit',
            field: 'misc_unit',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Charge Type", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Y','N'],
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        //   {
        //       label: 'Charge Type',
        //       field: 'description',
        //       fpFieldType:"text",
        //       hidden:false,
        //       filterable: true,
        //       filterOptions: {
        //           enabled: false, // enable filter for this column
        //           placeholder: "Charge Type", // placeholder for filter input
        //           filterValue: '', // initial populated value for this filter
        //           trigger: "enter" //only trigger on enter not on keyup
        //       },
        //   },
        {
            label: 'Unit Number',
            field: 'unit_no',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Unit Description',
            field: 'name',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Serial Number',
            field: 'vin',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'VMRS System',
            field: 'vmrs',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
        },
        {
            label: 'Part',
            field: 'item',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Description',
            field: 'item_name',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Hours',
            field: 'hours',
            filterable: true,
            fpFieldType:"integer",
            type:'number',
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Quantity',
            field: 'inv_line_qty',
            fpFieldType:"integer",
            type: 'number',
            //   sortable: false,
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Qty", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        
        {
            label: 'Unit Price',
            field: 'inv_line_unit_price',
            fpFieldType:"integer",
            //   sortable: false,
            type:'number',
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Price", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        {
            label: 'Sublet Amount',
            field: 'sublet_amount',
            fpFieldType:"integer",
            //   sortable: false,
            filterable: false,
            type:'number',
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Qty", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false

        },
        {
            label: 'Internal Amount',
            field: 'internal_amount',
            fpFieldType:"integer",
            //   sortable: false,
            filterable: true,
            type:'number',
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Qty", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        {
            label: 'Tax',
            field: 'inv_line_pst_amount',
            fpFieldType:"integer",
            //   sortable: false,
            type:'number',
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Qty", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        {
            label: 'Total Line Amount',
            field: 'invoice_line_total',
            fpFieldType:"integer",
            //   sortable: false,
            type:'number',
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Qty", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        {
            label: 'Invoice Total Amount',
            field: 'invoice_amount',
            fpFieldType:"integer",
            //   sortable: false,
            type:'number',
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Inv Line Total", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },

        },
        {
            label: 'WO Reading1',
            field: 'reading1',
            filterable: false,
            fpFieldType:"integer",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'Reading1 UOM',
            field: 'uom1',
            filterable: false,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'WO Reading2',
            field: 'reading2',
            filterable: false,
            fpFieldType:"integer",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'Reading2 UOM',
            field: 'uom2',
            filterable: false,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'WO Reading3',
            field: 'reading3',
            filterable: false,
            fpFieldType:"integer",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'Reading3 UOM',
            field: 'uom3',
            filterable: false,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'Equipment Type',
            field: 'asset_type',
            filterable: true,
            fpFieldType:"option",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Source Document Line", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Equipment Group',
            field: 'group',
            filterable: true,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "WO Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'WO Type',
            field: 'wo_type',
            filterable: false,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "WO Number Line Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
        {
            label: 'Customer PO',
            field: 'customer_po_no',
            filterable: true,
            fpFieldType:"text",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Agreement Number", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        ],
    }),
    watch:{
        permissions: function(permission) {
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'customer_invoice_line_detail_report') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    created: function () {
        this.serverParams.stopRequest = true;
    },
    mounted: function(){
        var self = this;

        self.getPermissions();
    },
    methods:{
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        cancelAll: function (cancelAll) {
        this.$refs.leaseContractReportTable.unselectAllInternal();
        },
        loadList: function(){
        var self = this;
        self.loading = true;
        var date = new Date();
        var offset = date.getTimezoneOffset();

        $.ajax({
            url: process.env.ROOT_API + "/emms-invoice-detail-report/list",
            type: "POST",
            crossDomain: true,
            headers: this.ajxHeaders,
            dataType: "json",
            data: {
            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: this.serverParams.columnFilters,
            sort: this.serverParams.sort,
            offset: offset,
            action: self.action
            },
            success: function(data) {
            self.loading = false;
            //console.log(data.content[0]["id"]);
            console.log(data.content.row);
            if (data.status == "success") {

                if ( self.action == "export" ||  self.action == "export_queue") {

                    if ( data.code == "201" ) {
                        alert(data.message);
                    } else {

                        if ( self.action == "export" ) {

                            self.excel = data.content.web;
                            var save = document.createElement("a");
                            save.href = self.excel;
                            save.download = data.content.web;
                            save.target = "_blank";

                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);

                        } else {

                            self.batchProcess = 1;
                            self.batchNum = data.content;
                        }

                    }

                self.action = "list";
                self.loadList();
                return;

                } else {
                if (data.content.row != undefined) {
                    self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
                }


            }
            },
            error: function(jqXHR, exception) {
            self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'lease-contract-list')
            }
        });


        }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/CustomerInvoiceLineDetailReport.vue